<template>
  <CustomSidebar
    v-model:visible="this.visible"
    exitLabel="Close"
    position="full"
    :title="reportTbl.title"
    @hide="$emit('close')"
    v-if="reportTbl"
  >
    <template #actions>
      <Button
        label="Excel"
        icon="pi pi-file-excel pi-fw"
        class="p-button-success"
        @click="reportTbl.content1 ? tableToExcelMultipleSheet() : tableToExcel()"
      />
    </template>
    <table>
      <tbody v-html="reportTbl.header"></tbody>
    </table>
    <div v-if="reportTbl.content1">
      <TabView>
          <TabPanel header="Summary">
            <div class="tableFixHead" v-html="reportTbl.content" />
          </TabPanel>
          <TabPanel header="Detail">
            <div class="tableFixHead" v-html="reportTbl.content1" />
          </TabPanel>
      </TabView>
                  
    </div>
    <div v-else>
      <div class="tableFixHead" v-html="reportTbl.content" />
    </div>
  </CustomSidebar>
</template>
<script>

export default {
  emits: ["close"],
  props: {
    reportTbl: {
      type: Object,
      default: null,
    },
    isVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible:false,
    };
  },
  watch:{
    isVisible(newVal,oldVal){
      this.visible=newVal;
    }
  },
  methods: {
    tableToExcel() {
      var uri = "data:application/vnd.ms-excel;base64,",
        template =
          `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
            <head><!--[if gte mso 9]><xml>
            <x:ExcelWorkbook>
              <x:ExcelWorksheets>
                <x:ExcelWorksheet>
                  <x:Name>{worksheet}</x:Name>
                  <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                </x:ExcelWorksheet>
              </x:ExcelWorksheets>      
            </x:ExcelWorkbook></xml><![endif]-->
            <meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head>
            <body><table>{table}</table></body></html>`,
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };
      var ctx = {
        worksheet: "Default" || "Worksheet",
        table: this.reportTbl.header + this.reportTbl.content,
      };
      var currentDate = this.$moment().format("DD-MM-yyyy_hh-mm");
      var fileName = this.reportTbl.title + "_" + currentDate;
      const link = document.createElement("a");
      link.href = uri + base64(format(template, ctx));
      link.download = fileName;
      link.click();
    },
    tableToExcelMultipleSheet() {
            var uri = 'data:application/vnd.ms-excel;base64,'
                , html_start = `<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">`
                , template_ExcelWorksheet = `<x:ExcelWorksheet><x:Name>{SheetName}</x:Name><x:WorksheetSource HRef="sheet{SheetIndex}.htm"/></x:ExcelWorksheet>`
                , template_ListWorksheet = `<o:File HRef="sheet{SheetIndex}.htm"/>`
                , template_HTMLWorksheet = `
------=_NextPart_dummy
Content-Location: sheet{SheetIndex}.htm
Content-Type: text/html; charset=windows-1252

` + html_start + `
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=windows-1252">
  <link id="Main-File" rel="Main-File" href="../WorkBook.htm">
  <link rel="File-List" href="filelist.xml">
</head>
<body>{SheetContent}</body>
</html>`
                , template_WorkBook = `MIME-Version: 1.0
X-Document-Type: Workbook
Content-Type: multipart/related; boundary="----=_NextPart_dummy"

------=_NextPart_dummy
Content-Location: WorkBook.htm
Content-Type: text/html; charset=windows-1252

` + html_start + `
<head>
<meta name="Excel Workbook Frameset">
<meta http-equiv="Content-Type" content="text/html; charset=windows-1252">
<link rel="File-List" href="filelist.xml">
<!--[if gte mso 9]><xml>
 <x:ExcelWorkbook>
  <x:ExcelWorksheets>{ExcelWorksheets}</x:ExcelWorksheets>
  <x:ActiveSheet>0</x:ActiveSheet>
 </x:ExcelWorkbook>
</xml><![endif]-->
</head>
<frameset>
  <frame src="sheet0.htm" name="frSheet">
  <noframes><body><p>This page uses frames, but your browser does not support them.</p></body></noframes>
</frameset>
</html>
{HTMLWorksheets}
Content-Location: filelist.xml
Content-Type: text/xml; charset="utf-8"

<xml xmlns:o="urn:schemas-microsoft-com:office:office">
  <o:MainFile HRef="../WorkBook.htm"/>
  {ListWorksheets}
  <o:File HRef="filelist.xml"/>
</xml>
------=_NextPart_dummy--
`
                , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }

            var context_WorkBook = {
                ExcelWorksheets: ''
                , HTMLWorksheets: ''
                , ListWorksheets: ''
            };

            var sheetNameSummary = "Summary";
            
            context_WorkBook.ExcelWorksheets += format(template_ExcelWorksheet, {
              SheetIndex: 0
              , SheetName: sheetNameSummary
            });

            context_WorkBook.HTMLWorksheets += format(template_HTMLWorksheet, {
                    SheetIndex: 0
                    , SheetContent: this.reportTbl.header + this.reportTbl.content
                });
                context_WorkBook.ListWorksheets += format(template_ListWorksheet, {
                    SheetIndex: 0
                });
            
            var sheetNameDetail = "Detail";

            context_WorkBook.ExcelWorksheets += format(template_ExcelWorksheet, {
              SheetIndex: 1
              , SheetName: sheetNameDetail
            });

            context_WorkBook.HTMLWorksheets += format(template_HTMLWorksheet, {
                    SheetIndex: 1
                    , SheetContent: this.reportTbl.content1
                });

              context_WorkBook.ListWorksheets += format(template_ListWorksheet, {
                  SheetIndex: 1
              });

            var currentDate = this.$moment().format("DD-MM-yyyy_hh-mm");
            var fileName = this.reportTbl.title + "_" + currentDate;
            var link = document.createElement("a");
            link.href = uri + base64(format(template_WorkBook, context_WorkBook));
            link.download = fileName;
            link.click();
        },
    showError(msg) {
      console.log(msg)
    },
  },
  mounted() {
    this.visible=this.isVisible
    console.log(this.visible)
  }
};
</script>

<style type="text/css" >
.dt-body-right {
  text-align: right;
}

.bgDone {
  background-color: rgba(130, 205, 55, 0.39);
}

.bgSigned {
  background-color: rgba(205, 205, 55, 0.39);
}

.bgPending {
  background-color: rgba(205, 55, 55, 0.39);
}

.bgPendingImport {
  background-color: rgba(55, 130, 205, 0.39);
}

.bgDelete {
  background-color: #808080;
}

.text {
  mso-number-format: "'"; /*force text*/
}

.noLabel {
  display: none;
}

.tableFixHead {
  overflow-y: auto;
  height: 70vh;
  /* top: -1px !important; */
}

.tableFixHead thead th {
  background: #ddd;
  position: sticky;
  top: 0;
}

.tableFixHead thead tr.second th{
  background: #ddd;
  position: sticky;
  top: 25px;
}

.tableFixHead thead tr.third th{
  background: #ddd;
  position: sticky;
  top: 50px;
}

.table-container {
  width: 100%;
  overflow-x: scroll;
  overflow-y: scroll;
}

/* Just common table stuff. */
table {
  /*border-collapse: collapse;*/
  width: 100%;
}

table td {
  border: 10px solid white;
  border-right: 0;
  border-left: 0;
}

.table-scroll {
  position: relative;
  width: 98%;
  z-index: 1;
  margin: auto;
  overflow: auto;
}

.table-scroll table {
  width: 98%;
  min-width: 1280px;
  margin: auto;
  border-collapse: separate;
  border-spacing: 0;
}

.table-wrap {
  position: relative;
}

.table-scroll tfoot th {
  padding: 5px 10px;
  border: 1px solid #000;
  background: #fff;
  vertical-align: top;
}

.table-scroll tfoot,
.table-scroll tfoot th {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  background: #ddd;
  color: #000;
  z-index: 4;
}

</style>
